import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectDropDownModule } from '@customcomponent/ngx-select-dropdown/ngx-select-dropdown.module';
import { SalaryBandDropdownComponent } from './salary-band-dropdown.component';

@NgModule({
  declarations: [SalaryBandDropdownComponent],
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule
  ],
  exports: [SalaryBandDropdownComponent]
})
export class SalaryBandDropdownModule { }
